// extracted by mini-css-extract-plugin
export var breadcrumbsContainer = "g_n";
export var centeredContent = "g_K";
export var heroWithTitle = "g_G";
export var pageContent = "g_t";
export var starIcon = "g_J";
export var subtitleContainer = "g_z";
export var titleContainer = "g_H";